import { render, staticRenderFns } from "./SchoolMessageBoard.vue?vue&type=template&id=d52b2cce&scoped=true"
import script from "./SchoolMessageBoard.vue?vue&type=script&lang=js"
export * from "./SchoolMessageBoard.vue?vue&type=script&lang=js"
import style0 from "./SchoolMessageBoard.vue?vue&type=style&index=0&id=d52b2cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52b2cce",
  null
  
)

export default component.exports